import { Component, OnInit,Output,EventEmitter, Input } from '@angular/core';
import { ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';

@Component({
  selector: 'app-ExpertCalibrationOption',
  templateUrl: './ExpertCalibrationOption.component.html',
  styleUrls: ['./ExpertCalibrationOption.component.scss']
})
export class ExpertCalibrationOptionComponent implements OnInit {

  @Input() inner_Expert_Site:boolean=true
  @Input() inner_Expert_Lab:boolean=false
  @Input() inner_Expert_SiteLab:boolean=true
  @Output() OnBack_ExpertCalibration_Action = new EventEmitter<Array<ExpertCalibration_Interface>>();

  Token: String = ""
  Filter_title: String = ""
  constructor(
    private Expert_CalibrationService: ExpertCalibrationService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Read_ExpertCalibration()
  }

  DataList_ExpertCalibration:Array<ExpertCalibration_Interface>=[]
  Read_ExpertCalibration(){
    this.Expert_CalibrationService.GetActiveList(this.Token,
      this.inner_Expert_Lab,
      this.inner_Expert_Site,
      this.inner_Expert_SiteLab).subscribe(
      data=>{
        this.DataList_ExpertCalibration=data

      }
    )
  }

  Change_Item_Status(item: ExpertCalibration_Interface)
  {
    item.del = !item.del
    this.set_Selected_Item()
  }

  set_Selected_Item() {
    var DataList_ExpertCalibrationTemp: Array<ExpertCalibration_Interface> = []
    for (let item of this.DataList_ExpertCalibration)
    {
      if (item.del)
      {
        DataList_ExpertCalibrationTemp.push(item)
      }
    }

    this.OnBack_ExpertCalibration_Action.emit(DataList_ExpertCalibrationTemp);
  }


}
